import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ShareVisibility_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', id: string, enabled: boolean, expiration?: string | null, expiresIn?: number | null };

export type ShareVisibility_CollectionShare_Fragment = { __typename?: 'CollectionShare', id: string, enabled: boolean, expiration?: string | null, expiresIn?: number | null };

export type ShareVisibilityFragment = ShareVisibility_AdHocAssetsShare_Fragment | ShareVisibility_CollectionShare_Fragment;

export const ShareVisibility = /*#__PURE__*/ gql`
    fragment ShareVisibility on Share {
  id
  enabled
  expiration
  expiresIn
}
    ` as unknown as DocumentNode<ShareVisibilityFragment, unknown>;

        

        
export const useShareVisibilityFragment = (
  input: string | Omit<UseFragmentOptions<ShareVisibilityFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<ShareVisibilityFragment>({
    fragment: ShareVisibility,
    fragmentName: 'ShareVisibility',
    ...options,
  });
};
  
        